module.exports = __webpack_public_path__ + "static/media/phone.36cd2a0d.png";